app.controller('studentHomeCtrl',function($rootScope, $scope, $timeout, $http, $state){
  $rootScope.inHome = true;
  $scope.$on('$destroy', function() {
    $rootScope.inHome = false;
  });

  $scope.data = {
    assignments:[],
    newAssignments:[],
    classes:[],
    statusText:['Not started','Inprogress','Submitted','Graded'],
  };
  $scope.dismiss = function(){
    if ($scope.data.showPicklist) {
      $scope.data.showPicklist = false;
    } else {
      $scope.data.showBackdrop = false;
      $scope.data.showExamStatus = false;
    }
  }
  $scope.preventDef = function(e){
    e.stopPropagation();
  }
  $scope.Date = Date;

  $scope.selectAssignment = function(item,e){
    if(e) e.stopPropagation();
    $scope.data.assignment = item;
    if(Date.now() > $scope.data.assignment.start && Date.now() < $scope.data.assignment.stop){
      if(!$scope.data.assignment.attempts || $scope.data.assignment.attempts.length==0){
        $scope.newAttempt()
      }else if($scope.data.assignment.attempts.length==1 && $scope.data.assignment.attempts[0].status<2){
        $scope.loadAttempt($scope.data.assignment.attempts[0]);
      }else{
        $scope.data.showBackdrop = true;
        $scope.data.showExamStatus = true;
      }
    }else{
      $scope.data.showBackdrop = true;
      $scope.data.showExamStatus = true;
    }
  }

  $scope.$watch('data.showExamStatus',function(showExamStatus){
    function loadAttempt(attempt){
      $http({
         method: 'GET',
         url: $rootScope.school.database+'/api/student/'+$rootScope.profile.idStudent
          +'/assignments/attempt/'+attempt.idStudentAssignment,
         headers: {
           Authorization: 'Bearer '+localStorage.getItem('studentToken'),
         }
       })
      .then(function(res){
        if(res && res.data && res.data.attempt && res.data.responses){
          attempt.responses = res.data.responses;
          attempt.answers = 0;
          attempt.grade = 0;
          for(var i = 0; i <attempt.responses.length; i++){
            attempt.grade += attempt.responses[i].value
            if(attempt.responses[i].status >= 1) attempt.answers++;
          }
          attempt.grade = Number(attempt.grade/$scope.data.assignment.questions*100).toFixed(2);
        }
      })
      .catch(function(err){
        console.log(err);
        alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
      });
    }
    if(showExamStatus){
      for(var i = 0; i < $scope.data.assignment.attempts.length; i++){
        loadAttempt($scope.data.assignment.attempts[0])
      }
    }
  });

  $scope.newAttempt = function(){
    $scope.data.working = true;
    $http({
      method: 'GET',
      url: $rootScope.school.database+'/api/student/'+$rootScope.profile.idStudent+'/assignments/'+$scope.data.assignment.idAssignment+'/attempt/new',
      headers: {
        Authorization: 'Bearer '+localStorage.getItem('studentToken'),
      }
    })
    .then(function(res){
      $scope.data.working = false;
      $state.go('assignment', {id: res.data.attempt.idStudentAssignment});
    })
    .catch(function(err){
      $scope.data.working = false;
      console.log(err);
      alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
    });
  }

  $scope.loadAttempt = function(item){
    $state.go('assignment', {id: item.idStudentAssignment});
  }
  $scope.reviewAttempt = function(item){
    $state.go('review', {id: item.idStudentAssignment});
  }

  $scope.updateAssignments = function(){
    if($scope.profile){
      return $http({
        method: 'GET',
        url: $rootScope.school.database+'/api/student/'+$scope.profile.idStudent+'/assignments',
        headers: {
          Authorization: 'Bearer '+localStorage.getItem('studentToken'),
        }
      })
      .then(function(res) {
        $scope.data.assignments = res.data.assignments;
        if($scope.data.assignments.length > 0){
          return $http({
           method: 'PUT',
           url: $rootScope.school.database+'/api/student/'+$scope.profile.idStudent+'/assignments',
           headers: {
             Authorization: 'Bearer '+localStorage.getItem('studentToken'),
           },
           data: {ids:$scope.data.assignments.map(function(i){return i.idAssignment})}
          }).catch(function(err){
            console.log(err);
            alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
          });
        }
        return({data:{attempts:[]}});
      })
      .then(function(res) {
        for(var i = 0; i < $scope.data.classes.length; i++){
          $scope.data.classes[i].assignments = [];
          $scope.data.classes[i].assignments = [];
        }
        for(var i = 0; i < $scope.data.assignments.length; i++){
          var index = $scope.data.classes.findIndex(function(c){return c.idClass==$scope.data.assignments[i].fkClass});
          if(index >= 0){
            if(!$scope.data.classes[index].assignments)$scope.data.classes[index].assignments = [];
            $scope.data.classes[index].assignments.push($scope.data.assignments[i]);
            $scope.data.assignments[i].class = $scope.data.classes[index];
          }
        }
        for(var i = 0; i < res.data.attempts.length; i++){
          var index = $scope.data.assignments.findIndex(function(c){return c.idAssignment==res.data.attempts[i].fkAssignment});
          if(index >= 0){
            if(!$scope.data.assignments[index].attempts)$scope.data.assignments[index].attempts = [];
            if($scope.data.assignments[index].status < res.data.attempts[i].status)$scope.data.assignments[index].status = res.data.attempts[i].status;
            $scope.data.assignments[index].attempts.push(res.data.attempts[i]);
          }
        }
        $scope.data.newAssignments = $scope.data.assignments.filter((a)=>a.stop > Date.now() && a.status < 2);
      })
      .catch(function(err){
        console.log(err);
        alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
      });
    } else {
      return Promise.resolve(false);
    }
  }
  $scope.updateClasses = function(){
    if($scope.profile){
      return $http({
       method: 'GET',
       url: $rootScope.school.database+'/api/student/'+$scope.profile.idStudent+'/classes',
       headers: {
         Authorization: 'Bearer '+localStorage.getItem('studentToken'),
       }
      }).then(function(res){
        $scope.data.classes = res.data.classes;
        if($scope.data.classes.length > 0)
          $scope.updateAssignments();
      }).catch(function(err){
        console.log(err);
        alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
      });
    }
  }

  $scope.$on('$destroy', function() {
    if($scope.data.updateInterval){
      clearInterval($scope.data.updateInterval);
    }
  })
  $scope.$on('$destroy', $rootScope.$on('addClassByCode', function() {
    if($scope.profile){
      bootbox.prompt("Class Code:", function(result){
        if(result){
          $http({
            method: 'GET',
            url: $rootScope.school.database+'/api/student/'+$rootScope.profile.idStudent+'/classes/'+result+'/add',
            headers: {
              Authorization: 'Bearer '+localStorage.getItem('studentToken'),
            }
          })
          .then(function(res){
           if(res && res.data){
             if(!res.data.error){
                $scope.updateClasses();
                alertify.success('class added');
              } else {
                alertify.error(res.data.error);
              }
            } else {
              alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
            }
        })
          .catch(function(err){
            console.log(err);
            alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
          });
        }
      });
    }
  }));
  $rootScope.$watch('profile',function(profile){
    if(profile){
      $scope.profile = profile;
      if($rootScope.schools){
        for(var i = 0; i < $rootScope.schools.length; i++){
          if($rootScope.schools[i].idSchool==profile.fkSchool)
            $rootScope.school = $rootScope.schools[i];
        }

        if(!$scope.data.updateInterval){
          $scope.updateClasses();

          $scope.data.updateInterval = setInterval(function () {
            if($scope.data.classes.length > 0)
              $scope.updateAssignments();
          }, 30000);
        }
      }
    }
  });
  $rootScope.$watch('schools',function(schools){
    if(schools && $scope.profile){
      for(var i = 0; i < $rootScope.schools.length; i++){
        if($rootScope.schools[i].idSchool==$scope.profile.fkSchool)
          $rootScope.school = $rootScope.schools[i];
      }

      if(!$scope.data.updateInterval){
        $scope.updateClasses();

        $scope.data.updateInterval = setInterval(function () {
          if($scope.data.classes.length > 0)
            $scope.updateAssignments();
        }, 30000);
      }
    }
  });
});
